export const GLOBAL_VARIABLES_QUERY_KEY = 'globalVariables' as const;

export const globalVariablesKeys = {
  byName: (name: string) => [GLOBAL_VARIABLES_QUERY_KEY, 'name', name] as const
} as const;
